export default __webpack_public_path__ + "static/media/bus.e1b8b2f5.png";